<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="fixed inset-0 z-50 overflow-hidden" role="dialog" aria-modal="true">

            <!-- Backdrop -->
            <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="close"></div>

            <!-- Modal Container -->
            <div class="relative flex min-h-full items-end sm:items-center justify-center">
                <Transition name="modal-slide">
                    <div v-if="isdisplay" class="art-modal">

                        <!-- ========== HEADER (charte : cf-modal-head) ========== -->
                        <div class="art-modal-head cf-modal-head">
                            <div class="cf-modal-head__main">
                                <span class="cf-modal-head__icon"><i class="ri-archive-2-line"></i></span>
                                <div class="min-w-0">
                                    <h2 class="art-title truncate">{{ titlemodal }}</h2>
                                    <p class="cf-modal-head__sub">Gestion de votre catalogue articles</p>
                                </div>
                            </div>
                            <button @click="close" type="button" class="art-close" aria-label="Fermer">
                                <i class="ri-close-line"></i>
                            </button>
                        </div>

                        <!-- ========== TOOLBAR ========== -->
                        <div class="toolbar">
                            <div class="toolbar-row">

                                <!-- Recherche -->
                                <div class="search-wrap">
                                    <i class="ri-search-line search-icon"></i>
                                    <input v-model="searchword" type="text" class="search-input" placeholder="Rechercher un article..." />
                                    <button v-if="searchword" @click="searchword = ''" class="search-clear">
                                        <i class="ri-close-circle-fill"></i>
                                    </button>
                                </div>

                                <div class="toolbar-actions">

                                    <!-- Compteur licence -->
                                    <span class="art-quota" :class="quota.used >= quota.max ? 'art-quota--full' : ''">
                                        <i class="ri-price-tag-3-line"></i> <b>{{ quota.used }}</b> / {{ quota.max }}
                                    </span>

                                    <!-- Ajouter -->
                                    <button @click="btnajouter" :disabled="quota.used >= quota.max"
                                            :title="quota.used >= quota.max ? 'Limite de licence atteinte' : ''"
                                            class="ti-btn ti-btn-primary-full">
                                        <i class="ri-add-line align-middle"></i><span>Ajouter</span>
                                    </button>

                                    <!-- Colonnes -->
                                    <div style="position:relative;">
                                        <button @click.stop="toggleMenu('cols')"
                                                :class="['btn btn--columns', openMenu === 'cols' ? 'btn--columns--active' : '']"
                                                title="Gérer les colonnes" type="button">
                                            <i class="ri-layout-column-line"></i>
                                            <span>Colonnes</span>
                                            <span v-if="countActiveColumns > 0" class="col-count-badge">{{ countActiveColumns }}</span>
                                            <i :class="['ri-arrow-down-s-line col-arrow', openMenu === 'cols' ? 'col-arrow--open' : '']"></i>
                                        </button>
                                        <Transition name="col-panel-fade">
                                            <div v-if="openMenu === 'cols'" class="art-panel" @click.stop>
                                                <div class="art-panel__header">
                                                    <span class="art-panel__title"><i class="ri-layout-column-line"></i> Colonnes visibles</span>
                                                </div>
                                                <div class="art-panel__body">
                                                    <label v-for="(col, index) in columnsConfig" :key="index"
                                                           class="col-toggle-item" :class="getColumnValue(col.key) ? 'col-toggle-item--on' : ''">
                                                        <input type="checkbox" :checked="getColumnValue(col.key)" @change="toggleColumn(col.key)" style="display:none;" />
                                                        <span class="col-toggle-check"><i v-if="getColumnValue(col.key)" class="ri-check-line"></i></span>
                                                        <span class="col-toggle-label">{{ col.label }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </Transition>
                                    </div>

                                    <!-- Filtres -->
                                    <div style="position:relative;">
                                        <button @click.stop="toggleMenu('filters')"
                                                :class="['btn btn--columns', (openMenu === 'filters' || hasActiveFilters) ? 'btn--columns--active' : '']"
                                                type="button">
                                            <i class="ri-filter-3-line"></i>
                                            <span>Filtres</span>
                                            <span v-if="countActiveFilters > 0" class="col-count-badge">{{ countActiveFilters }}</span>
                                            <i :class="['ri-arrow-down-s-line col-arrow', openMenu === 'filters' ? 'col-arrow--open' : '']"></i>
                                        </button>
                                        <Transition name="col-panel-fade">
                                            <div v-if="openMenu === 'filters'" class="art-panel art-panel--wide" @click.stop>
                                                <div class="art-panel__body" style="padding:12px 14px;">
                                                    <p class="art-group-label">Type d'article</p>
                                                    <div class="art-chip-row">
                                                        <button v-for="type in typeArticleOptions" :key="type.value"
                                                                @click="typearticle = type.value"
                                                                :class="['cf-chip', typearticle === type.value ? 'cf-chip--on' : '']">
                                                            {{ type.label }}
                                                        </button>
                                                    </div>
                                                    <p class="art-group-label" style="margin-top:12px;">Fiche technique</p>
                                                    <div class="art-chip-row">
                                                        <button v-for="fiche in ficheTechniqueOptions" :key="fiche.value"
                                                                @click="affichagefichetechnique = fiche.value"
                                                                :class="['cf-chip', affichagefichetechnique === fiche.value ? 'cf-chip--on' : '']">
                                                            {{ fiche.label }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Transition>
                                    </div>

                                    <!-- Actions -->
                                    <div style="position:relative;">
                                        <button @click.stop="toggleMenu('actions')" class="ds-btn-ghost" type="button">
                                            <i class="ri-more-2-fill"></i><span>Actions</span>
                                            <i :class="['ri-arrow-down-s-line col-arrow', openMenu === 'actions' ? 'col-arrow--open' : '']"></i>
                                        </button>
                                        <Transition name="col-panel-fade">
                                            <ul v-if="openMenu === 'actions'" class="ag-menu ag-menu--wide" @click.stop>
                                                <li>
                                                    <button @click="btnmodallistearticletrt('ensommeil');openMenu=null" class="ag-menu-item">
                                                        <i class="ri-moon-line cf-menu-icon"></i> Articles/services inactifs
                                                    </button>
                                                </li>
                                                <li>
                                                    <button @click="btnmodallistearticletrt('suivistock');openMenu=null" class="ag-menu-item">
                                                        <i class="ri-bar-chart-box-line cf-menu-icon"></i> Articles sans suivi de stock
                                                    </button>
                                                </li>
                                                <li>
                                                    <button @click="btnmodalmajpunormalise();openMenu=null" class="ag-menu-item">
                                                        <i class="ri-percent-line cf-menu-icon"></i> Générer prix normalisé
                                                    </button>
                                                </li>
                                                <li v-if="afficheview">
                                                    <button @click="btnmaintenancestock();openMenu=null" class="ag-menu-item ag-menu-item--danger">
                                                        <i class="ri-tools-line cf-menu-icon"></i> Correction du stock
                                                    </button>
                                                </li>
                                            </ul>
                                        </Transition>
                                    </div>

                                    <!-- Actualiser -->
                                    <button @click="loadtrt" class="ds-btn-ghost" title="Actualiser" type="button">
                                        <i class="ri-refresh-line"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Tags des filtres actifs -->
                            <div v-if="hasActiveFilters" class="art-tags">
                                <span class="art-tags__label">Filtres :</span>
                                <span v-if="searchword" class="art-tag">
                                    "{{ searchword.substring(0, 15) }}{{ searchword.length > 15 ? '…' : '' }}"
                                    <button @click="searchword = ''"><i class="ri-close-line"></i></button>
                                </span>
                                <span v-if="typearticle" class="art-tag">
                                    {{ typearticle }}
                                    <button @click="typearticle = ''"><i class="ri-close-line"></i></button>
                                </span>
                                <span v-if="affichagefichetechnique" class="art-tag">
                                    Fiche : {{ affichagefichetechnique === '1' ? 'Oui' : 'Non' }}
                                    <button @click="affichagefichetechnique = ''"><i class="ri-close-line"></i></button>
                                </span>
                                <button @click="clearAllFilters" class="btn-reset">
                                    <i class="ri-filter-off-line"></i><span>Tout effacer</span>
                                </button>
                            </div>
                        </div>

                        <!-- ========== TABLE ZONE ========== -->
                        <div class="table-zone">
                            <div class="table-scroll-wrap art-scroll">

                                <!-- ===== MOBILE : cartes ===== -->
                                <div class="block sm:hidden">
                                    <template v-if="!loadingtable">
                                        <div v-for="n in 4" :key="n" class="skeleton-row" :style="{ opacity: 1 - n * 0.15, margin:'10px 16px' }"></div>
                                    </template>

                                    <template v-else-if="filterdatatable.length">
                                        <div v-for="(datavalue, index) in filterdatatable" :key="index" class="mobile-card">
                                            <img v-if="articlePhotoUrl(datavalue.photoarticle)" :src="articlePhotoUrl(datavalue.photoarticle)" alt="Photo" class="art-thumb art-thumb--mobile" loading="lazy" decoding="async" @click="btnmodalphoto(datavalue)" />
                                            <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;">
                                                <div style="display:flex;align-items:center;gap:10px;min-width:0;flex:1;">
                                                    <div class="avatar--sm"><i class="ri-price-tag-3-line"></i></div>
                                                    <div style="min-width:0;flex:1;">
                                                        <div style="font-weight:600;color:var(--cf-ink-strong);font-size:14px;" class="truncate">{{ datavalue.libelle }}</div>
                                                        <p style="font-size:12px;color:var(--cf-muted);">{{ datavalue.catalogue || 'Non classé' }}</p>
                                                    </div>
                                                </div>
                                                <div style="text-align:right;flex-shrink:0;">
                                                    <p style="font-weight:700;color:var(--cf-ink-strong);">{{ formatMoney(datavalue.pa) }}</p>
                                                    <p style="font-size:11px;color:var(--cf-faint);">FCFA</p>
                                                </div>
                                            </div>
                                            <div class="mobile-extra-chips">
                                                <span class="code-badge">{{ datavalue.taxedimposition || 'N/A' }}</span>
                                                <span :class="['badge', datavalue.suividestock === 1 ? 'badge--green' : 'badge--red']">
                                                    <i :class="datavalue.suividestock === 1 ? 'ri-check-line' : 'ri-close-line'"></i>
                                                    Stock {{ datavalue.suividestock === 1 ? 'Oui' : 'Non' }}
                                                </span>
                                                <span v-if="datavalue.arsommeil === 1" class="badge" style="background:#fef9c3;color:#a16207;">
                                                    <i class="ri-moon-line"></i> Sommeil
                                                </span>
                                            </div>
                                            <div class="mobile-card__actions">
                                                <button @click="btnmodifier(datavalue)" class="mobile-action"><i class="ri-edit-line"></i> Modifier</button>
                                                <button @click="generercodebarre(datavalue.codebarre, datavalue.libelle)" class="mobile-action"><i class="ri-qr-code-line"></i></button>
                                                <button @click="btnmodalphoto(datavalue)" class="mobile-action"><i class="ri-image-add-line"></i></button>
                                                <button @click="btnsuppression(datavalue)" class="mobile-action mobile-action--danger"><i class="ri-delete-bin-line"></i></button>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="empty-state">
                                            <div class="empty-state__icon"><i class="ri-search-eye-line"></i></div>
                                            <p class="empty-state__title">Aucun résultat</p>
                                            <p class="empty-state__sub">Modifiez vos critères de recherche.</p>
                                            <button @click="clearAllFilters" class="ti-btn ti-btn-primary-full" style="margin-top:14px;">Réinitialiser</button>
                                        </div>
                                    </template>
                                </div>

                                <!-- ===== DESKTOP : table ===== -->
                                <table class="hidden sm:table art-table">
                                    <thead class="table-head">
                                    <tr>
                                        <th class="th">Article / Services</th>
                                        <th v-if="activecolums9" class="th th--center">Photo</th>
                                        <th v-if="activecolums5" class="th">Unité</th>
                                        <th class="th">Catalogue</th>
                                        <th class="th">Type régime</th>
                                        <th class="th th--right">Prix d'achat</th>
                                        <th v-if="activecolums8" class="th">Destination</th>
                                        <th v-if="activecolums6" class="th th--center">Suivi stock</th>
                                        <th v-if="activecolums2" class="th">Code barre</th>
                                        <th v-if="activecolums3" class="th th--center">Périssable</th>
                                        <th v-if="activecolums1" class="th th--center">Sommeil</th>
                                        <th v-if="activecolums7" class="th">Accompagnements</th>
                                        <th v-if="activecolums4" class="th">Créé le</th>
                                        <th class="th th--center" style="width:120px;">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    <!-- Loading -->
                                    <template v-if="!loadingtable">
                                        <tr v-for="n in 6" :key="n">
                                            <td colspan="20" style="padding:6px 16px;"><div class="skeleton-row" :style="{ opacity: 1 - n * 0.12 }"></div></td>
                                        </tr>
                                    </template>

                                    <!-- Data -->
                                    <template v-else-if="filterdatatable.length">
                                        <tr v-for="(datavalue, index) in filterdatatable" :key="index" class="table-row">
                                            <!-- Article -->
                                            <td class="td">
                                                <div style="display:flex;align-items:center;gap:10px;">
                                                    <div class="avatar--sm"><i class="ri-price-tag-3-line"></i></div>
                                                    <div style="min-width:0;">
                                                        <p style="font-weight:500;color:var(--cf-ink-strong);" class="truncate" :style="{maxWidth:'220px'}">{{ datavalue.libelle }}</p>
                                                        <p v-if="datavalue.reference" style="font-size:11px;color:var(--cf-faint);" class="truncate">Réf : {{ datavalue.reference }}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <!-- Photo -->
                                            <td v-if="activecolums9" class="td td--center">
                                                <img v-if="articlePhotoUrl(datavalue.photoarticle)" :src="articlePhotoUrl(datavalue.photoarticle)" alt="Photo" class="art-thumb" loading="lazy" decoding="async" @click="btnmodalphoto(datavalue)" title="Voir / changer la photo" />
                                                 
                                            </td>
                                            <!-- Unité -->
                                            <td v-if="activecolums5" class="td">{{ datavalue.unite || '—' }}</td>
                                            <!-- Catalogue -->
                                            <td class="td"><span class="code-badge code-badge--gray">{{ datavalue.catalogue || 'Non classé' }}</span></td>
                                            <!-- Type régime -->
                                            <td class="td"><span class="cf-st cf-st--info">{{ datavalue.taxedimposition || '—' }}</span></td>
                                            <!-- Prix -->
                                            <td class="td td--right">
                                                <span style="font-weight:600;color:var(--cf-ink-strong);">{{ formatMoney(datavalue.pa) }}</span>
                                                <span style="font-size:11px;color:var(--cf-faint);margin-left:3px;">FCFA</span>
                                            </td>
                                            <!-- Destination -->
                                            <td v-if="activecolums8" class="td" style="font-size:0.75rem;">{{ datavalue.destination || '—' }}</td>
                                            <!-- Suivi stock -->
                                            <td v-if="activecolums6" class="td td--center">
                                                <span :class="['badge', datavalue.suividestock === 1 ? 'badge--green' : 'badge--red']">
                                                    <i :class="datavalue.suividestock === 1 ? 'ri-check-line' : 'ri-close-line'"></i>
                                                    {{ datavalue.suividestock === 1 ? 'Oui' : 'Non' }}
                                                </span>
                                            </td>
                                            <!-- Code barre -->
                                            <td v-if="activecolums2" class="td">
                                                <span v-if="datavalue.codebarre" class="code-badge">{{ datavalue.codebarre }}</span>
                                                <span v-else class="text-muted">—</span>
                                            </td>
                                            <!-- Périssable -->
                                            <td v-if="activecolums3" class="td td--center">
                                                <i :class="datavalue.perisable ? 'ri-timer-flash-line' : 'ri-subtract-line'"
                                                   :style="{ color: datavalue.perisable ? '#f59e0b' : 'var(--cf-faint)', fontSize:'1.1rem' }"></i>
                                            </td>
                                            <!-- Sommeil -->
                                            <td v-if="activecolums1" class="td td--center">
                                                <span :class="['badge', datavalue.arsommeil === 1 ? '' : 'badge--green']"
                                                      :style="datavalue.arsommeil === 1 ? 'background:#fef9c3;color:#a16207;' : ''">
                                                    <i :class="datavalue.arsommeil === 1 ? 'ri-moon-line' : 'ri-sun-line'"></i>
                                                    {{ datavalue.arsommeil === 1 ? 'Oui' : 'Non' }}
                                                </span>
                                            </td>
                                            <!-- Accompagnements -->
                                            <td v-if="activecolums7" class="td" style="font-size:0.75rem;">{{ datavalue.arsommeil === 1 ? 'Oui' : 'Non' }}</td>
                                            <!-- Créé le -->
                                            <td v-if="activecolums4" class="td" style="font-size:0.75rem;">
                                                <span style="display:inline-flex;align-items:center;gap:4px;"><i class="ri-calendar-line" style="color:var(--cf-faint);"></i>{{ datavalue.creerler }}</span>
                                            </td>
                                            <!-- Actions -->
                                            <td class="td td--center" style="overflow:visible;" @click.stop>
                                                <div class="art-row-actions">
                                                    <button @click="btnmodifier(datavalue)" class="art-icon-btn" title="Modifier"><i class="ri-edit-line"></i></button>
                                                    <button @click="generercodebarre(datavalue.codebarre, datavalue.libelle)" class="art-icon-btn" title="Code barre"><i class="ri-qr-code-line"></i></button>
                                                    <button @click="btnmodalphoto(datavalue)" class="art-icon-btn" title="Photos"><i class="ri-image-add-line"></i></button>
                                                    <div class="ti-btn-group" style="position:relative;display:inline-block;">
                                                        <button class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]" type="button"
                                                                :aria-expanded="openMenu === 'row_' + index" @click.stop="toggleMenu('row_' + index)">
                                                            <i class="ri-more-2-fill"></i>
                                                        </button>
                                                        <ul v-show="openMenu === 'row_' + index" class="ag-menu">
                                                            <li>
                                                                <button @click="btnmodifier(datavalue);openMenu=null" class="ag-menu-item">
                                                                    <i class="ri-pen-nib-line cf-menu-icon"></i> Modifier
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button @click="generercodebarre(datavalue.codebarre, datavalue.libelle);openMenu=null" class="ag-menu-item">
                                                                    <i class="ri-qr-code-line cf-menu-icon"></i> Code barre
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button @click="btnmodalphoto(datavalue);openMenu=null" class="ag-menu-item">
                                                                    <i class="ri-image-add-line cf-menu-icon"></i> Photos
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button @click="btnsuppression(datavalue);openMenu=null" class="ag-menu-item ag-menu-item--danger">
                                                                    <i class="ri-delete-bin-line cf-menu-icon"></i> Supprimer
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Empty -->
                                    <template v-else>
                                        <tr>
                                            <td colspan="20">
                                                <div class="empty-state">
                                                    <div class="empty-state__icon"><i class="ri-search-eye-line"></i></div>
                                                    <p class="empty-state__title">Aucun résultat trouvé</p>
                                                    <p class="empty-state__sub">Essayez de modifier vos critères de recherche.</p>
                                                    <button @click="clearAllFilters" class="ti-btn ti-btn-primary-full" style="margin-top:14px;">
                                                        <i class="ri-refresh-line align-middle"></i> Réinitialiser les filtres
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- ========== FOOTER ========== -->
                        <div class="footer-bar">
                            <p class="footer-info" v-if="allItems > 0">
                                Affichage <strong>{{ ((page - 1) * perPage) + 1 }}–{{ Math.min(page * perPage, allItems) }}</strong> sur <strong>{{ allItems }}</strong>
                            </p>
                            <p class="footer-info" v-else>&nbsp;</p>

                            <nav v-if="pages.length > 1" class="pagination">
                                <button @click="page--" :disabled="page <= 1" class="page-btn page-btn--nav"><i class="ri-arrow-left-s-line"></i></button>
                                <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                    <span v-if="pageNumber === '...'" style="padding:0 4px;color:var(--cf-faint);font-size:13px;">…</span>
                                    <button v-else @click="page = pageNumber" :class="['page-btn', pageNumber === page ? 'page-btn--active' : 'page-btn--default']">{{ pageNumber }}</button>
                                </template>
                                <button @click="page++" :disabled="page >= pages.length" class="page-btn page-btn--nav"><i class="ri-arrow-right-s-line"></i></button>
                            </nav>

                            <button @click="close" class="ti-btn ti-btn-danger-full">
                                <i class="ri-close-line align-middle"></i> Fermer
                            </button>
                        </div>

                    </div>
                </Transition>
            </div>
        </div>
    </Transition>

    <!-- Sub-modals -->
    <modalcodebarre ref="modalcodebarre"></modalcodebarre>
    <modalform ref="modalform" @closed="loadtrt"></modalform>
    <modallistearticletrt ref="modallistearticletrt" @closed="loadtrt"></modallistearticletrt>
    <modalformsuppression @closed="loadtrt" ref="modalformsuppression"></modalformsuppression>
    <modalmajpunormalise @closed="loadtrt" ref="modalmajpunormalise"></modalmajpunormalise>
    <modalphotoarticle ref="modalphotoarticle"></modalphotoarticle>
</template>

<script>
    import { mapGetters } from "vuex";
    const axios = require('axios');

    import modalform from "@/components/views/pages/stock/articles/form";
    import modalcodebarre from "@/components/views/pages/stock/articles/modal_codebarre";
    import modalformsuppression from "@/components/views/pages/stock/articles/formsuppression";
    import modallistearticletrt from "@/components/views/pages/stock/articles/modal_listearticletrt";
    import modalmajpunormalise from "@/components/views/pages/stock/articles/modal_majpunormalise";
    import modalphotoarticle from "@/components/views/pages/stock/articles/modal_photoarticle";

    import { cloneobjet, currencyFormatDE, isset, issetObject, randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue, oldvalue) {
                this.page = 1
            },
            DefaultperPage: function(newvalue, oldvalue) {
                this.page = 1
            },
            typearticle: function(newvalue, oldvalue) {
                this.page = 1
            },
        },

        computed: {
            ...mapGetters(['listedesarticles']),

            // Configuration des colonnes pour le dropdown
            columnsConfig() {
                return [
                    { key: 'activecolums5', label: 'Unité' },
                    { key: 'activecolums1', label: 'Article en sommeil' },
                    { key: 'activecolums2', label: 'Code barre' },
                    { key: 'activecolums3', label: 'Périssable' },
                    { key: 'activecolums4', label: 'Créé le' },
                    { key: 'activecolums6', label: 'Suivi de stock' },
                    { key: 'activecolums7', label: 'Accompagnements' },
                    { key: 'activecolums8', label: 'Destination' },
                    { key: 'activecolums9', label: 'Photo' },
                ]
            },

            // Options pour le filtre type article
            typeArticleOptions() {
                return [
                    { value: '', label: 'Tous' },
                    { value: 'Article', label: 'Articles' },
                    { value: 'matierspremiere', label: 'Matières premières' },
                ]
            },

            // Options pour le filtre fiche technique
            ficheTechniqueOptions() {
                return [
                    { value: '', label: 'Tous', activeClass: 'bg-primary text-white' },
                    { value: '0', label: 'Sans fiche', activeClass: 'bg-red-500 text-white' },
                    { value: '1', label: 'Avec fiche', activeClass: 'bg-green-500 text-white' },
                ]
            },

            // Compteur des colonnes actives
            countActiveColumns() {
                let count = 0;
                if (this.activecolums1) count++;
                if (this.activecolums2) count++;
                if (this.activecolums3) count++;
                if (this.activecolums4) count++;
                if (this.activecolums5) count++;
                if (this.activecolums6) count++;
                if (this.activecolums7) count++;
                if (this.activecolums8) count++;
                if (this.activecolums9) count++;
                return count;
            },

            // Compteur des filtres actifs
            countActiveFilters() {
                let count = 0;
                if (this.typearticle) count++;
                if (this.affichagefichetechnique) count++;
                return count;
            },

            // Vérifie si des filtres sont actifs
            hasActiveFilters() {
                return this.searchword || this.typearticle || this.affichagefichetechnique;
            },

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);
                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },

            filterdatatable() {
                let mvalue = cloneobjet(this.listedesarticles)
                this.perPage = this.DefaultperPage;

                if (this.typearticle !== '') {
                    let t = this;
                    mvalue = mvalue.filter(function(post) {
                        return post.typearticle.toLowerCase().includes(t.typearticle.toLowerCase())
                    })
                }

                if (this.affichagefichetechnique !== '') {
                    let t = this;
                    mvalue = mvalue.filter(function(post) {
                        return post.fichetechnique.toString().toLowerCase().includes(t.affichagefichetechnique.toString().toLowerCase())
                    })
                }

                if (this.searchword !== '') {
                    let t = this;
                    mvalue = mvalue.filter(function(post) {
                        return post.libelle.toLowerCase().includes(t.searchword.toLowerCase())
                    })
                }



                const allowedPids = new Set(this.returnGetAllmagasin.map(m => m.pid));
                mvalue = mvalue.filter(function(post) {
                    const jsonarticles = post.jsonarticles || [];
                    return jsonarticles.some(item => item?.mg?.pid && allowedPids.has(item.mg.pid));
                });

                  this.allItems = mvalue.length;

                return this.paginate(mvalue);
            },

            returnGetAllmagasin() {
                if (!this.$store.state.annexeuser || this.$store.state.annexeuser.length === 0) {
                    return this.otherdata.allmagasin || [];
                }
                return this.$store.state.annexeuser;
            },
        },

        components: {
            modalform,
            modalformsuppression,
            modalcodebarre,
            modallistearticletrt,
            modalmajpunormalise,
            modalphotoarticle,
        },

        data() {
            return {
                afficheview: true,
                loadingtable: true,
                isdisplay: false,
                openMenu: null,
                titlemodal: "",
                datatable: [],
                quota: { max:100, used:0, atteint:false },
                listedupersonnel: [],
                datatiers: [],
                otherdata: [],
                typedoc: "",
                messageerror: "",
                messagesucces: "",
                typearticle: "",
                affichagefichetechnique: "",
                ismodalviewcodebarre: false,

                activecolums1: false,
                activecolums2: false,
                activecolums3: false,
                activecolums4: false,
                activecolums5: false,
                activecolums6: false,
                activecolums7: false,
                activecolums8: false,
                activecolums9: false,

                searchword: "",
                searchtrierletableau: "",

                allItems: 0,
                lastkey: 0,
                paginationpage: 1,
                nextPage: 1,
                countItems: 1,
                countPageItems: 0,

                posts: [''],
                page: 1,
                perPage: 250,
                Defaultpage: 1,
                DefaultperPage: 250,
                pages: [],
            };
        },

        methods: {
            // ── Menus (charte : un seul menu ouvert + clic extérieur) ──
            toggleMenu(key) {
                this.openMenu = this.openMenu === key ? null : key;
            },

            handleGlobalClick(e) {
                if (!e.target.closest('.ti-btn-group')
                    && !e.target.closest('.art-panel')
                    && !e.target.closest('.ag-menu')
                    && !e.target.closest('.btn--columns')
                    && !e.target.closest('.ds-btn-ghost')) {
                    this.openMenu = null;
                }
            },

            // Méthodes pour gérer les colonnes dynamiquement
            getColumnValue(key) {
                return this[key];
            },

            toggleColumn(key) {
                this[key] = !this[key];
            },

            // Effacer tous les filtres
            clearAllFilters() {
                this.searchword = '';
                this.typearticle = '';
                this.affichagefichetechnique = '';
            },

            async btnmaintenancestock() {
                const t = this;
                t.$store.dispatch('lancerchargement', true)

                let $datedebut = '2024-11-10', $datefin = '2024-11-13';

                let url = process.env.VUE_APP_API_URL + '/maintenance/stock/line/' + this.$store.state.appsociete + '/' + $datedebut + '/' + $datefin + '/' + randomString();
                let response = axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    },
                    withCredentials: true
                })

                let res = await response
                    .then(function(res) {
                        t.$store.dispatch('lancerchargement', false)
                        if (res.data.success) {
                            console.log(res.data)
                        }
                    })
                    .catch((error) => {
                        t.$store.dispatch('lancerchargement', false)
                    })
                    .finally(() => {})
            },

            btnmodalmajpunormalise(value) {
                this.$refs.modalmajpunormalise.show();
            },

            btnmodallistearticletrt(value) {
                this.$refs.modallistearticletrt.show(value);
            },

            generercodebarre(valuecodebarre, valuename) {
                this.$refs.modalcodebarre.show(valuecodebarre, valuename);
            },

            btnmodalphoto(value) {
                this.$refs.modalphotoarticle.show(value);
            },

            articlePhotoUrl(datavalue) {

                //let p = (datavalue && datavalue.datajsonarticles && datavalue.datajsonarticles.photo) ? datavalue.datajsonarticles.photo : '';
                let p = datavalue;
                console.log('articlePhotoUrl', p)
                let mvalue = p ? (this.$store.state.baseurlapifile + p) : '';

                  console.log('articlePhotoUrl mvalue', mvalue)
                return mvalue;
            },

            formatMoney(value) {
                return currencyFormatDE(value)
            },

            btnajouter() {
                if (this.quota.used >= this.quota.max) {
                    toastr['error']("Limite d'articles atteinte ("+this.quota.used+"/"+this.quota.max+"). Contactez votre support.","<b></b>");
                    return;
                }

                let mname = "Enregistrer un article"

                let Item = {
                    pid: '',
                    libelle: '',
                    reference: '',
                    suividestock: 0,
                    articletype: 0,
                    nbreusearticle: 0,
                    usear: 0,
                    stockminimum: 0,
                    lignetitre: '',
                    lignedescription: '',
                    lignedescriptiontotal: '',
                    lignephotodegarde: '',
                    lignesommeil: '',
                    lignein_stock: '',
                    lignecategorie: '',
                    lignesous_categorie: '',
                    lignemontant: '',
                    ligneremise: '',
                    lignenbredevue: '',
                    ligneboutique: '',
                    ligneboutiquepid: '',
                    datajsonarticles: {
                        typearticle: "Article",
                        destination: "ACHAT_ET_VENTE",
                        perisable: false,
                        ensommeil: false,
                        fichetechnique: 0,
                        tptva: 1,
                        stockminimum: 0,
                        stockmaximum: 0,
                        magasin: null,
                        unite: null,
                        catalogue: null,
                        comptetva: {
                            compteventeexport: null,
                            comptefacturation: null,
                            compteventelocal: null
                        },
                        normalisation: {
                            taxedimposition: "E",
                            tauxtaxedimposition: null,
                            tauxtaxespecifique: null,
                            descriptiondutsapplique: null
                        },
                        tarification: {
                            prixvente1: 0,
                            prixvente2: 0,
                            prixvente3: 0,
                            prixvente4: 0,
                            prixvente5: 0,
                            prixvente6: 0,
                            prixvente7: 0,
                            prixachat: 0,
                            prixvente: 0,
                            typeprixvente: 0,
                            prixpromo: 0,
                            typttc: 1.18,
                        },
                        information: {
                            info: '',
                            info1: '',
                            info2: '',
                            info3: ''
                        },
                        paramdindication: {
                            param: null,
                            param1: null,
                            param2: [],
                            param3: {
                                typeoperation: 'default',
                                suiviedemballage: 'Non',
                                emballage: null
                            }
                        },

                        emplacement: { rayon: '', couloir: '', etagere: '' },

                    },
                    articlesenligne: {
                        titreenligne: '....',
                        montantenligne: 0,
                        montantremiseenligne: 0,
                        minidescriptionenligne: '.....',
                        totaldescriptionenligne: '......',
                        categorieenligne: null,
                        souscategorieenligne: null,
                        lesphotosenligne: [],
                        articledisponible: true,
                        miseenligne: false,
                    },
                    articlesenrestaurant: {
                        accompagnement: [],
                        categorieplat:'PLAT'
                    },
                    articlesclinique: [],
                };

                const jsonarticles = this.returnGetAllmagasin.map(magasin => ({
                    pidligne: "",
                    mgp: magasin.mg,
                    mg: magasin,
                    pv: [],
                    pu: 0,
                    pu1: 0,
                    pu2: 0,
                    pu3: 0,
                    pu4: 0,
                    pu5: 0,
                    pu6: 0,
                    pu7: 0,
                    pa: 0,
                    stockminimum: 0,
                    stockmaximum: 0,
                    selected: false
                }));

                this.$refs.modalform.show(mname, "add", Item, this.datainputlibelleforms, this.otherdata, jsonarticles);
            },

            btnmodifier(value) {
                let mname = "Modification de l'article : " + value.libelle

                let Item = value;

                // Normalisation des anciens articles (clés absentes en base)
                /*if (!issetObject(value.datajsonarticles)) {
                    value.datajsonarticles = {};
                }*/

                if (!issetObject(value.datajsonarticles.emplacement)) {
                    value.datajsonarticles.emplacement = { rayon: '', couloir: '', etagere: '' };
                }

                if (!issetObject(value.articlesenrestaurant)) {
                    value.articlesenrestaurant = { accompagnement: [], categorieplat: 'PLAT' };
                }

                if (!isset(value.articlesenrestaurant.categorieplat)) {
                    value.articlesenrestaurant.categorieplat = 'PLAT';
                }

                let jsonarticles = this.returnGetAllmagasin.map(magasin => ({
                    pidligne: "",
                    mgp: magasin.mg,
                    mg: magasin,
                    pv: [],
                    pu: 0,
                    pu1: 0,
                    pu2: 0,
                    pu3: 0,
                    pu4: 0,
                    pu5: 0,
                    pu6: 0,
                    pu7: 0,
                    pa: 0,
                    stockminimum: 0,
                    stockmaximum: 0,
                    selected: false
                }));

                let valuejsonarticles = value.jsonarticles.map(item => ({
                    ...item,
                    selected: true
                }));

                const valuePids = new Set(valuejsonarticles
                    .filter(item => item?.mg?.pid)
                    .map(item => item.mg.pid)
                );

                const filtered = jsonarticles.filter(item =>
                    item?.mg?.pid && !valuePids.has(item.mg.pid)
                );

                let newjsonarticles = [...filtered, ...valuejsonarticles];

                const allowedPids = new Set(this.returnGetAllmagasin.map(m => m.pid));
                newjsonarticles = newjsonarticles.filter(item => item?.mg?.pid && allowedPids.has(item.mg.pid));

                this.$refs.modalform.show(mname, "update", Item, this.datainputlibelleforms,
                    this.otherdata, newjsonarticles, value.accompagnement);
            },

            async load() {
                const q = await this.$store.dispatch('loadlistedesarticles')
                if (q) this.quota = q
            },

            async loadtrt() {
                const q = await this.$store.dispatch('resetloadlistedesarticles')
                if (q) this.quota = q
            },

            async loadinputlibelleforms() {
                let $VALUEDATAPRICE = JwtService.getVALUEDATAPRICE()

                if (isset($VALUEDATAPRICE)) {
                    this.datainputlibelleforms = JSON.parse($VALUEDATAPRICE);
                } else {
                    const t = this;
                    let url = process.env.VUE_APP_API_URL + '/12478855libelinputindex2iofdofiloadexp2/' + this.$store.state.appsociete + '/' + randomString();
                    let response = axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    })

                    let res = await response
                        .then(function(res) {
                            t.$store.dispatch('lancerchargement', false)
                            if (res.data.success) {
                                t.datainputlibelleforms = [];
                                t.datainputlibelleforms = res.data.valuedataprice;
                                JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms))
                            } else {
                                t.datainputlibelleforms = [];
                            }
                        })
                        .catch((error) => {
                            t.$store.dispatch('lancerchargement', false)
                        })
                        .finally(() => {
                            t.$store.dispatch('lancerchargement', false)
                        })
                }
            },

            async loadreturnotherdata() {
                const t = this;
                let url = process.env.VUE_APP_API_URL + '/ar85474524otherdatadofodfidfoioienf55485/' + this.$store.state.appsociete + '/' + randomString();
                let response = axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    },
                    withCredentials: true
                })

                let res = await response
                    .then(function(res) {
                        t.$store.dispatch('lancerchargement', false)
                        if (res.data.success) {
                            t.otherdata = [];
                            t.otherdata = res.data.otherdata;
                        } else {
                            t.otherdata = [];
                        }
                    })
                    .catch((error) => {
                        t.$store.dispatch('lancerchargement', false)
                    })
                    .finally(() => {
                        t.$store.dispatch('lancerchargement', false)
                    })
            },

            btnsuppression(value) {
                if (value.nbreusearticle === 1 || value.nbreusearticle === '1') {
                    toastr['error']("Impossible de supprimer cet article. Veuillez contacter votre administrateur.", "<b></b>");
                    return
                }

                let titlemodal = "VOULLEZ-VOUS VRAIMENT SUPPRIMER " + value.libelle + " ?";
                this.$refs.modalformsuppression.show(titlemodal, value);
            },

            close() {
                this.isdisplay = false;
            },

            selected(datavalue) {
                const elementSelectionne = {
                    typ: this.typedoc,
                    value: datavalue
                };
                this.$emit('elementSelectionne', elementSelectionne);
                this.isdisplay = false;
            },

            show(titlemodal) {
                this.typearticle = "";
                this.affichagefichetechnique = "";
                this.messagesucces = "";
                this.messageerror = "";
                this.titlemodal = titlemodal;

                this.loadreturnotherdata();
                this.loadinputlibelleforms();
                this.isdisplay = true;
            },

            setPages(posts) {
                this.pages = [];
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },

            paginate(posts) {
                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res = posts.slice(from, to)

                if ($res.length > 0) {
                    return $res;
                } else {
                    return posts;
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick)
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick)
        }
    }
</script>

<style scoped>
/* ------------------------------------------------------------------ *
 * Charte cf-/ds- : couleurs via tokens (var(--cf-*), rgb(var(--...))). *
 * Portée depuis newhpaie/agents. Light-only.                          *
 * ------------------------------------------------------------------ */

/* ===== MODALE ===== */
.art-modal { position:relative; width:100%; max-width:95vw; max-height:92vh; margin:0 auto;
    display:flex; flex-direction:column; background:#fff; border-radius:var(--cf-radius);
    box-shadow:var(--cf-shadow-md); overflow:hidden; }
@media (max-width:640px) { .art-modal { max-width:100%; max-height:95vh; border-radius:var(--cf-radius) var(--cf-radius) 0 0; } }

.art-modal-head { flex-shrink:0; padding:0.9rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); }
.art-title { margin:0; font-size:1rem; font-weight:700; color:var(--cf-ink-strong); line-height:1.2; }
.art-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center;
    border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer;
    transition:all 0.15s; }
.art-close:hover { background:#fee2e2; color:rgb(var(--danger)); }

/* ===== TOOLBAR ===== */
.toolbar { flex-shrink:0; padding:0.75rem 1rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); }
.toolbar-row { display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
.search-wrap { position:relative; flex:1; min-width:200px; max-width:400px; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm);
    font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.toolbar-actions { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }

/* Compteur licence */
.art-quota { display:inline-flex; align-items:center; gap:4px; padding:6px 10px; border-radius:999px;
    border:1px solid var(--cf-border); background:#fff; font-size:0.75rem; color:var(--cf-muted); font-weight:600; }
.art-quota b { color:var(--cf-ink-strong); font-weight:800; }
.art-quota--full { border-color:#fecaca; background:#fef2f2; color:rgb(var(--danger)); }
.art-quota--full b { color:rgb(var(--danger)); }

/* Bouton colonnes / filtres */
.btn { display:inline-flex; align-items:center; gap:6px; padding:8px 14px; border:none; border-radius:var(--cf-radius-sm);
    font-size:0.82rem; font-weight:600; cursor:pointer; transition:all 0.18s; }
.btn--columns { background:#fff; border:1px solid rgb(var(--input-border,203 213 225)); color:var(--cf-ink); }
.btn--columns:hover { border-color:rgb(var(--primary)); color:rgb(var(--primary)); }
.btn--columns--active { border-color:rgb(var(--primary)); color:rgb(var(--primary)); background:rgb(var(--primary) / 0.08); }
.col-count-badge { display:inline-flex; align-items:center; justify-content:center; min-width:20px; height:20px; padding:0 5px;
    background:rgb(var(--primary)); color:#fff; border-radius:10px; font-size:0.66rem; font-weight:700; }
.col-arrow { font-size:16px; transition:transform 0.2s; }
.col-arrow--open { transform:rotate(180deg); }

/* Panneau déroulant (colonnes / filtres) */
.art-panel { position:absolute; right:0; top:calc(100% + 6px); width:300px; background:#fff; border:1px solid var(--cf-border);
    border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); z-index:200; overflow:hidden; display:flex; flex-direction:column; max-height:420px; }
.art-panel--wide { width:340px; }
.art-panel__header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); }
.art-panel__title { font-size:0.8rem; font-weight:700; color:var(--cf-ink-strong); display:flex; align-items:center; gap:6px; }
.art-panel__body { overflow-y:auto; flex:1; display:flex; flex-wrap:wrap; gap:6px; padding:12px; }
.art-panel--wide .art-panel__body { display:block; }
.art-group-label { font-size:0.66rem; font-weight:700; color:var(--cf-faint); text-transform:uppercase; letter-spacing:.5px; margin:0 0 6px; }
.art-chip-row { display:flex; flex-wrap:wrap; gap:6px; }

.col-toggle-item { display:inline-flex; align-items:center; gap:6px; padding:5px 10px; border:1px solid rgb(var(--input-border,203 213 225));
    border-radius:var(--cf-radius-xs); cursor:pointer; transition:all 0.15s; background:#fff; user-select:none; }
.col-toggle-item:hover { border-color:rgb(var(--primary)); }
.col-toggle-item--on { border-color:rgb(var(--primary)); background:rgb(var(--primary) / 0.08); }
.col-toggle-check { width:16px; height:16px; border:1.5px solid var(--cf-border); border-radius:4px; display:flex; align-items:center; justify-content:center;
    font-size:0.66rem; color:rgb(var(--primary)); flex-shrink:0; transition:all 0.15s; }
.col-toggle-item--on .col-toggle-check { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.col-toggle-label { font-size:0.75rem; color:var(--cf-ink); white-space:nowrap; }

.col-panel-fade-enter-active, .col-panel-fade-leave-active { transition:all 0.2s ease; }
.col-panel-fade-enter-from, .col-panel-fade-leave-to { opacity:0; transform:translateY(-6px) scale(0.98); }

/* Menu 3 points */
.ag-menu { position:absolute; top:calc(100% + 4px); right:0; z-index:30; min-width:180px; margin:0; padding:0.3rem; list-style:none;
    background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); box-shadow:var(--cf-shadow-md); }
.ag-menu--wide { min-width:260px; }
.ag-menu-item { display:flex; align-items:center; width:100%; padding:0.45rem 0.6rem; border:0; background:transparent; font-size:0.8rem;
    color:var(--cf-ink); text-align:left; cursor:pointer; border-radius:var(--cf-radius-xs); white-space:nowrap; }
.ag-menu-item:hover { background:var(--cf-surface-alt); }
.ag-menu-item--danger { color:rgb(var(--danger)); }
.ag-menu-item--danger .cf-menu-icon { color:rgb(var(--danger)); }

/* Bouton reset */
.btn-reset { display:inline-flex; align-items:center; gap:4px; padding:6px 12px; background:none; border:none; color:var(--cf-muted); font-size:0.78rem; cursor:pointer; }
.btn-reset:hover { color:rgb(var(--primary)); }

/* Tags filtres actifs */
.art-tags { display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-top:10px; }
.art-tags__label { font-size:0.72rem; color:var(--cf-faint); }
.art-tag { display:inline-flex; align-items:center; gap:5px; padding:3px 9px; border-radius:999px; background:rgb(var(--primary) / 0.08);
    color:rgb(var(--primary)); font-size:0.72rem; font-weight:600; }
.art-tag button { background:none; border:none; color:inherit; cursor:pointer; display:inline-flex; }

/* ===== TABLE ===== */
.table-zone { flex:1; overflow:hidden; padding:0; }
.table-scroll-wrap { overflow:auto; }
.art-scroll { height:52vh; }
@media (max-width:768px) { .art-scroll { height:auto; max-height:70vh; } }
.art-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:640px; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink);
    background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }
.td--right { text-align:right; }
.text-muted { color:var(--cf-faint); }

.avatar--sm { width:34px; height:34px; min-width:34px; background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); border-radius:var(--cf-radius-sm);
    display:flex; align-items:center; justify-content:center; font-size:0.9rem; font-weight:700; }

.art-thumb { width:100px; height:100px; object-fit:cover; border-radius:var(--cf-radius-sm); border:1px solid var(--cf-border); cursor:pointer; display:inline-block; vertical-align:middle; background:#fff; }
@media (max-width:640px) { .art-thumb { height:100%; } }
.art-thumb--mobile { display:block; width:100%; max-height:180px; margin-bottom:10px; }
.art-thumb--empty { display:inline-flex; align-items:center; justify-content:center; color:var(--cf-muted); background:var(--cf-surface-alt); font-size:1.1rem; }
.art-thumb--empty:hover { color:rgb(var(--primary)); border-color:rgb(var(--primary)); }

.code-badge { font-family:monospace; font-size:0.7rem; padding:2px 8px; background:var(--cf-surface-alt); color:var(--cf-ink); border-radius:var(--cf-radius-xs); font-weight:600; }
.code-badge--gray { background:var(--cf-surface-alt); color:var(--cf-muted); font-family:inherit; }

.badge { display:inline-flex; align-items:center; gap:4px; padding:2px 9px; border-radius:999px; font-size:0.66rem; font-weight:700; }
.badge--green { background:#dcfce7; color:#15803d; }
.badge--red { background:#fee2e2; color:#b91c1c; }

/* pastilles cf-st (utilise charte.css global, fallback si absent) */
.cf-st { display:inline-block; font-size:0.66rem; font-weight:700; padding:2px 9px; border-radius:999px; }
.cf-st--info { background:#dbeafe; color:#1d4ed8; }

/* Actions de ligne */
.art-row-actions { display:inline-flex; align-items:center; gap:2px; }
.art-icon-btn { height:28px; width:28px; border-radius:var(--cf-radius-xs); border:none; background:transparent; color:var(--cf-muted);
    cursor:pointer; display:inline-flex; align-items:center; justify-content:center; transition:all 0.15s; }
.art-icon-btn:hover { background:var(--cf-surface-alt); color:rgb(var(--primary)); }

/* Skeleton */
.skeleton-row { height:44px; background:linear-gradient(90deg, var(--cf-surface) 25%, var(--cf-surface-alt) 50%, var(--cf-surface) 75%);
    background-size:200% 100%; animation:skeleton 1.5s infinite; border-radius:var(--cf-radius-xs); }
@keyframes skeleton { 0% { background-position:200% 0; } 100% { background-position:-200% 0; } }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0 0 6px; }
.empty-state__sub { font-size:0.82rem; color:var(--cf-muted); margin:0; }

/* Mobile cards */
.mobile-card { padding:0.9rem 1rem; border-bottom:1px solid var(--cf-surface-alt); }
.mobile-extra-chips { display:flex; flex-wrap:wrap; gap:6px; margin-top:10px; }
.mobile-card__actions { display:flex; gap:8px; margin-top:12px; padding-top:12px; border-top:1px solid var(--cf-surface-alt); }
.mobile-action { display:inline-flex; align-items:center; gap:4px; padding:6px 10px; font-size:0.75rem; background:var(--cf-surface-alt);
    border:none; border-radius:var(--cf-radius-xs); color:var(--cf-ink); cursor:pointer; }
.mobile-action:hover { background:var(--cf-border); }
.mobile-action--danger { color:rgb(var(--danger)); }

/* ===== FOOTER / PAGINATION ===== */
.footer-bar { flex-shrink:0; display:flex; align-items:center; justify-content:space-between; padding:0.75rem 1rem;
    border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-wrap:wrap; gap:12px; }
.footer-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }
.pagination { display:flex; align-items:center; gap:4px; }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm);
    background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

/* ===== TRANSITIONS ===== */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.3s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.3s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(40px); }
@media (min-width:640px) {
    .modal-slide-enter-from, .modal-slide-leave-to { transform:scale(0.97) translateY(16px); }
}

/* Scrollbar fine */
.art-scroll::-webkit-scrollbar { width:6px; height:6px; }
.art-scroll::-webkit-scrollbar-track { background:transparent; }
.art-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }
.art-scroll::-webkit-scrollbar-thumb:hover { background:#94a3b8; }
</style>
